module.exports = __webpack_public_path__ + "media/sunset_ride.11dfc2ae.ogg";